import { render, staticRenderFns } from "./Subtask.vue?vue&type=template&id=7b5f1e6a&scoped=true&"
import script from "./Subtask.vue?vue&type=script&lang=js&"
export * from "./Subtask.vue?vue&type=script&lang=js&"
import style0 from "./Subtask.vue?vue&type=style&index=0&id=7b5f1e6a&lang=scss&scoped=true&"
import style1 from "./Subtask.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f1e6a",
  null
  
)

export default component.exports